import { LoginModeResponse } from '@asset-metrix/portal-auth';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store';
import { queryClient } from '../../utils/queryClient';

export function useLoginMode(email?: string) {
  const [initialLoginModeData, session] = useStore(
    useShallow((state) => [state.initialLoginModeData, state.session])
  );

  /* eslint-disable @tanstack/query/exhaustive-deps -- intentionally keep a single session-scoped cache key; helpers also read/write ['loginMode'] */
  return useSuspenseQuery({
    queryKey: ['loginMode'],
    queryFn: async () => {
      // @todo: portal-api does not return change password/reset URL with a request without an email even if there is
      // only a single SSO config for example. That's why we need to do a second request with the user email not matter
      // of the initial login mode. Ideally the second request would only be needed if `initialLoginModeData?.mode === 'multi'`
      if (email == null) {
        // No need to fetch again. The result will not change
        return initialLoginModeData;
      }

      return await session?.getLoginMode(email);
    },
    gcTime: Infinity,
  });
  /* eslint-enable @tanstack/query/exhaustive-deps */
}

export function getLoginModeData() {
  return queryClient.getQueryData<LoginModeResponse>(['loginMode']);
}

export function setLoginModeData(data?: LoginModeResponse) {
  return queryClient.setQueryData<LoginModeResponse>(['loginMode'], data);
}
